// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.site-nav[data-v-8f0d814e] {
  position: sticky;
  top: 0;
  z-index: 5000;
  padding: 16px 14px 0;
}
.site-nav-inner[data-v-8f0d814e] {
  width: min(1280px, calc(100vw - 8px));
  margin: 0 auto;
  min-height: 78px;
  padding: 14px 18px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 28px;
  display: flex;
  align-items: center;
  gap: 18px;
  background:
    radial-gradient(circle at left top, rgba(255, 240, 0, 0.16), transparent 22%),
    linear-gradient(135deg, rgba(22, 18, 10, 0.92), rgba(8, 9, 15, 0.94));
  backdrop-filter: blur(18px);
  box-shadow:
    0 18px 45px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
}
.site-brand[data-v-8f0d814e] {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #fff;
}
.site-brand-kicker[data-v-8f0d814e] {
  font-size: 11px;
  letter-spacing: 4px;
  color: rgba(255, 255, 255, 0.52);
}
.site-brand-logo[data-v-8f0d814e] {
  display: block;
  width: auto;
  height: 30px;
  object-fit: contain;
  filter:
    drop-shadow(0 0 10px rgba(255, 240, 0, 0.2))
    drop-shadow(0 2px 8px rgba(0, 0, 0, 0.35));
}
.site-links[data-v-8f0d814e] {
  display: flex;
  align-items: center;
  gap: 10px;
}
.site-link[data-v-8f0d814e] {
  min-height: 48px;
  padding: 12px 18px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.05);
  transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease;
}
.site-link[data-v-8f0d814e]:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.08);
}
.site-link.router-link-exact-active[data-v-8f0d814e],
.site-link.router-link-active[data-v-8f0d814e] {
  background: linear-gradient(180deg, #fff790, #fff000);
  color: #1a1300;
  font-weight: 700;
}
.site-dead-actions[data-v-8f0d814e] {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.site-pill[data-v-8f0d814e] {
  min-height: 42px;
  padding: 10px 14px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  color: #fff000;
  background: rgba(255, 240, 0, 0.08);
  border: 1px solid rgba(255, 240, 0, 0.16);
  font-size: 13px;
}
.site-dead-button[data-v-8f0d814e] {
  min-height: 42px;
  padding: 10px 14px;
  border-radius: 999px;
  border: 1px dashed rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.45);
  cursor: not-allowed;
}
@media (max-width: 980px) {
.site-nav-inner[data-v-8f0d814e] {
    flex-wrap: wrap;
}
.site-dead-actions[data-v-8f0d814e] {
    margin-left: 0;
    justify-content: flex-start;
}
}
@media (max-width: 720px) {
.site-nav[data-v-8f0d814e] {
    padding-top: 12px;
}
.site-nav-inner[data-v-8f0d814e] {
    padding: 14px;
    border-radius: 22px;
}
.site-brand-logo[data-v-8f0d814e] {
    height: 26px;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/SiteNavigation.vue"],"names":[],"mappings":";AA2BA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,oBAAoB;AACtB;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;;yEAEuE;EACvE,2BAA2B;EAC3B;;2CAEyC;AAC3C;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB;;8CAE4C;AAC9C;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,2CAA2C;EAC3C,qCAAqC;EACrC,sEAAsE;AACxE;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;AAEA;;EAEE,qDAAqD;EACrD,cAAc;EACd,gBAAgB;AAClB;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,yCAAyC;EACzC,eAAe;AACjB;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,mBAAmB;AACrB;AAEA;AACE;IACE,eAAe;AACjB;AAEA;IACE,cAAc;IACd,2BAA2B;AAC7B;AACF;AAEA;AACE;IACE,iBAAiB;AACnB;AAEA;IACE,aAAa;IACb,mBAAmB;AACrB;AAEA;IACE,YAAY;AACd;AACF","sourcesContent":["<template>\n  <header class=\"site-nav\">\n    <div class=\"site-nav-inner\">\n      <RouterLink class=\"site-brand\" to=\"/\">\n        <img\n          class=\"site-brand-logo\"\n          src=\"https://vcos.vds.pub/vds-pub-fonts/assets-627/BV627.png\"\n          alt=\"BV627\"\n        />\n      </RouterLink>\n\n      <nav class=\"site-links\" aria-label=\"Main navigation\">\n        <RouterLink class=\"site-link\" to=\"/\">首页</RouterLink>\n        <RouterLink class=\"site-link\" to=\"/library\">资源库</RouterLink>\n        <RouterLink class=\"site-link\" to=\"/about\">关于</RouterLink>\n      </nav>\n\n      <div class=\"site-dead-actions\" aria-label=\"Disabled utilities\">\n        <span class=\"site-pill\">没有搜索框</span>\n        <button class=\"site-dead-button\" type=\"button\" disabled>搜索没用</button>\n        <button class=\"site-dead-button\" type=\"button\" disabled>会员入口锁定</button>\n      </div>\n    </div>\n  </header>\n</template>\n\n<style scoped>\n.site-nav {\n  position: sticky;\n  top: 0;\n  z-index: 5000;\n  padding: 16px 14px 0;\n}\n\n.site-nav-inner {\n  width: min(1280px, calc(100vw - 8px));\n  margin: 0 auto;\n  min-height: 78px;\n  padding: 14px 18px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 28px;\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  background:\n    radial-gradient(circle at left top, rgba(255, 240, 0, 0.16), transparent 22%),\n    linear-gradient(135deg, rgba(22, 18, 10, 0.92), rgba(8, 9, 15, 0.94));\n  backdrop-filter: blur(18px);\n  box-shadow:\n    0 18px 45px rgba(0, 0, 0, 0.35),\n    inset 0 1px 0 rgba(255, 255, 255, 0.05);\n}\n\n.site-brand {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  color: #fff;\n}\n\n.site-brand-kicker {\n  font-size: 11px;\n  letter-spacing: 4px;\n  color: rgba(255, 255, 255, 0.52);\n}\n\n.site-brand-logo {\n  display: block;\n  width: auto;\n  height: 30px;\n  object-fit: contain;\n  filter:\n    drop-shadow(0 0 10px rgba(255, 240, 0, 0.2))\n    drop-shadow(0 2px 8px rgba(0, 0, 0, 0.35));\n}\n\n.site-links {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.site-link {\n  min-height: 48px;\n  padding: 12px 18px;\n  border-radius: 16px;\n  display: inline-flex;\n  align-items: center;\n  color: rgba(255, 255, 255, 0.88);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.05);\n  transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease;\n}\n\n.site-link:hover {\n  transform: translateY(-1px);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.site-link.router-link-exact-active,\n.site-link.router-link-active {\n  background: linear-gradient(180deg, #fff790, #fff000);\n  color: #1a1300;\n  font-weight: 700;\n}\n\n.site-dead-actions {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.site-pill {\n  min-height: 42px;\n  padding: 10px 14px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  color: #fff000;\n  background: rgba(255, 240, 0, 0.08);\n  border: 1px solid rgba(255, 240, 0, 0.16);\n  font-size: 13px;\n}\n\n.site-dead-button {\n  min-height: 42px;\n  padding: 10px 14px;\n  border-radius: 999px;\n  border: 1px dashed rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.03);\n  color: rgba(255, 255, 255, 0.45);\n  cursor: not-allowed;\n}\n\n@media (max-width: 980px) {\n  .site-nav-inner {\n    flex-wrap: wrap;\n  }\n\n  .site-dead-actions {\n    margin-left: 0;\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 720px) {\n  .site-nav {\n    padding-top: 12px;\n  }\n\n  .site-nav-inner {\n    padding: 14px;\n    border-radius: 22px;\n  }\n\n  .site-brand-logo {\n    height: 26px;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
